class Intro {
    id: string;
    name: string;
    dontShowAgain: boolean = false;
    private _showDontShowAgain: boolean;
    showDontShowAgain: boolean;
    steps: Array<IntroStep>;
    validation?: () => string;
    visibleOnList: boolean = true;

    constructor(id: string, name: string, steps: Array<IntroStep>, showDontShowAgain: boolean = true, validation?: () => string) {
        this.id = id;
        this.name = name;
        this.steps = steps;
        this._showDontShowAgain = showDontShowAgain ? true : false;
        this.validation = validation;
        this.visibleOnList = id !== "Intro"; // Hide the generic intro from the list
    }

    show(forceShow: boolean = false): boolean {
        this.showDontShowAgain = this._showDontShowAgain && !forceShow;

        if (forceShow || localStorage.getItem(`intro-${this.id}`) !== "true") {
            IntroService.show(this);
            return true;
        }
        return false;
    }

    save() {
        if (this.dontShowAgain && this.showDontShowAgain) {
            localStorage.setItem(`intro-${this.id}`, "true");
        }
    }
}